<template>
    <div class="messageoverlay-container" :style="{ top: topPx != null ? (topPx + 'px') : undefined }">

        <div class="message">
            <vs-button color="rgb(255,255,255)" @click="$emit('dismiss')" style="height: 30px; width: 30px;" class="dismiss"><img src="../assets/icons/x.png" style="opacity: 0.5; width: 12px; height: 12px;"/></vs-button>

            {{ message }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'messageOverlay',
    props: {
        message: String,
        anchorSelector: {
            type: String,
            default: '.poisearch-container'
        },
        offset: {
            type: Number,
            default: 8
        }
    },
    data() {
        return {
            topPx: null,
            mo: null,
            ro: null
        }
    },
    mounted() {
        this.reposition();
        window.addEventListener('resize', this.reposition, { passive: true });
        window.addEventListener('scroll', this.reposition, { passive: true });
        // retry after layout settles
        setTimeout(this.reposition, 50);
        setTimeout(this.reposition, 250);

        // Track changes to the anchor (height/class/children) so the overlay follows dynamically
        try {
            const anchor = document.querySelector(this.anchorSelector);
            if (anchor && 'MutationObserver' in window) {
                this.mo = new MutationObserver(() => this.reposition());
                this.mo.observe(anchor, { attributes: true, childList: true, subtree: true });
            }
            if (anchor && 'ResizeObserver' in window) {
                this.ro = new ResizeObserver(() => this.reposition());
                this.ro.observe(anchor);
            }
        } catch (e) { console.debug('MessageOverlay: observers setup skipped', e); }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.reposition);
        window.removeEventListener('scroll', this.reposition);
        try { if (this.mo) { this.mo.disconnect(); this.mo = null; } } catch (e) { console.debug('MessageOverlay: MO cleanup failed', e); }
        try { if (this.ro) { this.ro.disconnect(); this.ro = null; } } catch (e) { console.debug('MessageOverlay: RO cleanup failed', e); }
    },
    methods: {
        reposition() {
            this.$nextTick(() => {
                try {
                    const anchor = document.querySelector(this.anchorSelector);
                    if (anchor) {
                        const rect = anchor.getBoundingClientRect();
                        let bottom = rect.bottom;

                        // If mobile target chips are present (absolute positioned), ensure we clear them too
                        const chips = anchor.querySelector('.mobile-targets');
                        if (chips) {
                            const chipsRect = chips.getBoundingClientRect();
                            bottom = Math.max(bottom, chipsRect.bottom);
                        }

                        // If suggestions dropdown is open, place below it
                        const sugg = anchor.querySelector('.suggestions');
                        if (sugg) {
                            const suggRect = sugg.getBoundingClientRect();
                            bottom = Math.max(bottom, suggRect.bottom);
                        }

                        this.topPx = Math.round(bottom + this.offset + window.scrollY);
                        return;
                    }
                } catch (e) { console.debug('MessageOverlay: reposition fallback', e); }
                // Fallback relative to viewport height; safe-area is already accounted for
                // in surrounding layout (e.g., container padding) when in app mode.
                const baseVh = (this.$IS_APP ? 14 : 8);
                this.topPx = Math.round((window.innerHeight * baseVh) / 100);
            });
        }
    }
}
</script>

<style scoped>
.messageoverlay-container {
    z-index: 2090;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    padding: 0px;
    font-weight: 600;
    text-align: center;
}

.message {
    background: white;
    color: var(--primary);
    border-radius: 15px;
    padding: 10px 48px 10px 16px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    position: relative;

}

.dismiss {
    position: absolute;
    right: 8px;
    top: 8px;
    z-index: 1;
}

/* MOBILE */
@media (max-width: 600px) {
    .messageoverlay-container {
        padding-left: 25px;
        padding-right: 25px;
    }

    .message {
        padding: 10px 48px 10px 12px;
    }
}
</style>
<style>
.messageoverlay-container .vs-button {
    margin: 0!important;
    box-shadow: 0px 10px 20px -10px rgba(0,0,0, 0.5) !important;

}

body.app .messageoverlay-container {
    box-sizing: border-box!important;
    width: 100%!important;
    max-width: 500px!important;
}
</style>
